export default __webpack_public_path__ + "static/media/drop-in-visits.be60953f.svg";